import { FirstStepsCard } from '@/features/start/components/header/FirstStepsCard';
import { useTutorial } from '@/features/tutorial/providers/useTutorial';

export const useFirstStepsCard = () => {
  const { cardVisible: tutorialVisible } = useTutorial();

  if (!tutorialVisible) return;

  return <FirstStepsCard />;
};
